import React from 'react';
import { ImportDialog } from '../../../components/common';
import { cidCodeService } from '../../../services/cidCodeService';

interface CidCodesImportDialogProps {
  open: boolean;
  onClose: () => void;
  onImportComplete: () => void;
}

const CidCodesImportDialog: React.FC<CidCodesImportDialogProps> = ({
  open,
  onClose,
  onImportComplete,
}) => (
  <ImportDialog
    open={open}
    onClose={onClose}
    onImportComplete={onImportComplete}
    title="Importar Códigos CID-10"
    description="Selecione um arquivo Excel (.xlsx) com os códigos CID-10 para importar. Códigos já existentes serão ignorados."
    templateFileName="template-importacao-cid.xlsx"
    onDownloadTemplate={() => cidCodeService.downloadTemplate()}
    onImport={(file) => cidCodeService.importCidCodes(file)}
    entityLabel="código(s)"
  />
);

export default CidCodesImportDialog;
